import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  InboxMessagesUpdatedSubscription,
  InboxMessagesUpdatedSubscriptionVariables,
} from '#/graphql/generated';

export const INBOX_MESSAGES_UPDATED: TypedDocumentNode<
  InboxMessagesUpdatedSubscription,
  InboxMessagesUpdatedSubscriptionVariables
> = gql`
  subscription InboxMessagesUpdated {
    inboxMessagesUpdated {
      threadRootId
      participantUserIds
    }
  }
`;
